import React from 'react';

const VuetifyLogo = () => {
    return (
        <svg height="293" preserveAspectRatio="xMidYMid" viewBox="0 0 256 293" width="256" xmlns="http://www.w3.org/2000/svg"><path d="m128 0h-60l60 141.816367" fill="#1697f6"/><path d="m128 0h60l-60 141.816367" fill="#1867c0"/><path d="m128 182.743732v109.715707l-128-249.9019196h67.0490402" fill="#7bc6ff"/><path d="m128 182.746214v109.715707l128-249.9019196h-67.04904" fill="#aeddff"/></svg>
    )
}

export default VuetifyLogo;